export const NODE_ABI = [
  {
    type: 'function',
    name: 'burn',
    inputs: [{ name: '_tokenIds', type: 'uint256[]', internalType: 'uint256[]' }],
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    name: 'initialize',
    inputs: [
      { name: '_name', type: 'string', internalType: 'string' },
      { name: '_symbol', type: 'string', internalType: 'string' },
      { name: '_website', type: 'string', internalType: 'string' },
      { name: '_baseTokenURI', type: 'string', internalType: 'string' },
      { name: '_unlockTransferTime', type: 'uint256', internalType: 'uint256' },
    ],
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    name: 'mint',
    inputs: [
      { name: 'to', type: 'address', internalType: 'address' },
      { name: 'amount', type: 'uint256', internalType: 'uint256' },
    ],
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    name: 'safeMint',
    inputs: [
      { name: 'to', type: 'address', internalType: 'address' },
      { name: 'amount', type: 'uint256', internalType: 'uint256' },
      { name: 'data', type: 'bytes', internalType: 'bytes' },
    ],
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    name: 'setAddresses',
    inputs: [
      { name: '_factoryAddress', type: 'address', internalType: 'address' },
      { name: '_projectId', type: 'bytes32', internalType: 'bytes32' },
      { name: '_saleAddress', type: 'address', internalType: 'address' },
      { name: '_tierPriceAddress', type: 'address', internalType: 'address' },
      { name: '_rewardsAddress', type: 'address', internalType: 'address' },
      { name: '_redemptionAddress', type: 'address', internalType: 'address' },
    ],
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    name: 'setBaseURI',
    inputs: [{ name: 'baseTokenURI_', type: 'string', internalType: 'string' }],
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    name: 'setBurners',
    inputs: [
      { name: '_accounts', type: 'address[]', internalType: 'address[]' },
      { name: '_permissions', type: 'bool[]', internalType: 'bool[]' },
    ],
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    name: 'setMinters',
    inputs: [
      { name: '_accounts', type: 'address[]', internalType: 'address[]' },
      { name: '_permissions', type: 'bool[]', internalType: 'bool[]' },
    ],
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    name: 'setSuffixURI',
    inputs: [{ name: 'suffixURI_', type: 'string', internalType: 'string' }],
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    name: 'setTokenURI',
    inputs: [
      { name: '_tokenIds', type: 'uint256[]', internalType: 'uint256[]' },
      { name: '_tokenUris', type: 'string[]', internalType: 'string[]' },
    ],
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    name: 'setUriSetters',
    inputs: [
      { name: '_accounts', type: 'address[]', internalType: 'address[]' },
      { name: '_permissions', type: 'bool[]', internalType: 'bool[]' },
    ],
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    name: 'setWebsite',
    inputs: [{ name: '_descriptionLink', type: 'string', internalType: 'string' }],
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    name: 'setWhitelist',
    inputs: [
      { name: '_accounts', type: 'address[]', internalType: 'address[]' },
      { name: '_whitelisted', type: 'bool[]', internalType: 'bool[]' },
    ],
    outputs: [],
    stateMutability: 'nonpayable',
  },
];
